<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <!-- <a-form-item label="风险地区" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'riskAreaName', validatorRules.riskAreaName]" placeholder="请输入风险地区"></a-input>
        </a-form-item>
         -->
        <!-- 省市县级联 -->
        <!-- <a-row :gutter="24"> -->
          <a-form-item label="风险地区省市联级配置" prop="riskAreaName">
            <j-area-linkage v-model="formData.riskAreaName" type="select" @change="change" style="float: left"/>
            <!-- <span style="margin-left: 25px">输入的值(v-model)：{{ formData.riskAreaName }}</span> -->
          </a-form-item>
          <!-- <a-form-item label="是否禁用" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <j-dict-select-tag type="list" v-decorator="['delFlag', validatorRules.delFlag]" :trigger-change="true" dictCode="visitor_config_status" placeholder="请选择是否禁用"/>
          </a-form-item> -->
        <!-- </a-row> -->
      </a-form>
      
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JAreaLinkage from '../components/JAreaLinkage'

  export default {
    name: "BusRiskAreaConfigModal",
    components: { 
      JAreaLinkage
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          riskAreaName: {rules: [
          ]},
          delFlag: {rules: [
          ]},
        },
        url: {
          add: "/visitor/base/busRiskAreaConfig/add",
          edit: "/visitor/base/busRiskAreaConfig/edit",
        },
        formData: {
          riskAreaName: '',
          delFlag:0, //是否禁用，禁用1，启用0
        }
      }
    },
    created () {
    },
    methods: {
      change (value) {
        console.log('nowvalues', value)
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'riskAreaName','delFlag'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
          console.log('formData',this.formData)
        this.form.validateFields((err, values) => {
          console.log(values)
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,this.formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'riskAreaName','delFlag'))
      },

      
    }
  }
</script>